<template>
    <div class="personnel-management">

        <!-- 搜索和筛选区域 -->
        <div class="search-panel">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="组织名称" class="form-item">
                    <el-input v-model="searchForm.orgName" placeholder="请输入组织名称" clearable
                        class="search-input"></el-input>
                </el-form-item>

                <el-form-item class="form-item operate-btns">
                    <el-button type="primary" @click="getList" class="search-btn">
                        <i class="fa fa-search mr-1"></i>搜索
                    </el-button>
                    <el-button type="default" @click="resetSearch" class="reset-btn">
                        重置
                    </el-button>
                    <el-button type="primary" @click="showAddDialog" class="add-btn">
                        <i class="fa fa-plus mr-2"></i>新增组织
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 组织表格 -->
        <div class="table-container">
            <el-table :data="pagedPersonnel" border stripe :header-cell-style="tableHeaderStyle"
                @selection-change="handleSelectionChange" class="personnel-table" v-loading="loading"
                element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" height="66vh">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="序号" type="index" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="orgName" label="组织名称" min-width="130" align="center"></el-table-column>
                <el-table-column prop="orgCode" label="组织编码" min-width="130" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="120" align="center"></el-table-column>
                <el-table-column label="操作" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" class="edit-btn" @click="showEditDialog(scope.row)">
                            <i class="fa fa-pencil mr-1"></i>编辑
                        </el-button>
                        <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">
                            <i class="fa fa-trash-o mr-1"></i>删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="filteredPersonnel.length" class="pagination"
                :disabled="loading"></el-pagination>
        </div>

        <!-- 新增/编辑组织弹窗 -->
        <el-dialog :title="dialogType === 'add' ? '新增组织' : '编辑组织'" :visible.sync="dialogVisible" :width="dialogWidth"
            :close-on-click-modal="false" :z-index="3000" append-to-body>
            <el-form :model="form" :rules="formRules" ref="formRef" label-width="100px" class="form-modal">
                <el-row :gutter="20">
                    <el-col :span="24" :sm="12">
                        <el-form-item label="组织名称" prop="orgName">
                            <el-input v-model="form.orgName" placeholder="请输入组织名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="组织编码" prop="orgCode">
                            <el-input v-model="form.orgCode" placeholder="请输入组织编码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getOrgList, addOrg, editOrg, delOrg } from "@/api/organization";
export default {
    data() {
        return {


            // 组织数据
            personnelList: [], // 原始组织列表（后端返回）
            filteredPersonnel: [], // 筛选后组织列表
            pagedPersonnel: [], // 分页后组织列表

            // 搜索表单
            searchForm: {
                orgName: null
            },

            // 分页信息
            currentPage: 1,
            pageSize: 10,
            loading: false, // 全局加载状态

            // 选中的组织ID（批量操作备用）
            selectedIds: [],

            // 弹窗状态
            dialogVisible: false,
            dialogType: 'add',
            dialogWidth: '700px',

            // 表单数据（编辑时orgId为后端返回的组织唯一标识）
            form: {
                orgId: '', // 组织ID（编辑/删除必传，与后端字段保持一致）
                orgCode: '',
                orgName: ''
            },

            // 表单验证规则
            formRules: {
                orgName: [
                    { required: true, message: '请输入组织名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '组织名称长度需在1-50字符之间', trigger: 'blur' }
                ],
                orgCode: [
                    { required: true, message: '请输入组织编码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9_-]{3,20}$/, message: '编码仅支持字母、数字、_、-，长度3-20字符', trigger: 'blur' }
                ]
            },

            // 表格表头样式
            tableHeaderStyle: {
                background: '#f5f7fa',
                color: '#1D2129',
                fontWeight: '500'
            }
        };
    },

    computed: {
        // 计算总页数
        totalPages() {
            return Math.ceil(this.filteredPersonnel.length / this.pageSize);
        }
    },

    created() {
        // 初始化加载组织列表
        this.getList();
    },

    methods: {// 4. 重置搜索条件（核心修复：搜索框设为null，并重载列表）
        resetSearch() {
            // 重置搜索表单：orgName设为null（与初始值一致）
            this.searchForm = {
                orgName: null
            };
            // 重置页码为1（避免重置后停留在原页码导致数据为空）
            this.currentPage = 1;
            // 重新加载列表（传递null参数，获取全部数据）
            this.getList();
        },
        // 1. 获取组织列表（核心：与后端同步数据）
        getList() {
            this.loading = true;
            getOrgList({
                tenantId: null, // 按实际业务传递租户ID，无则传空,
                orgName: this.searchForm.orgName
            }).then(response => {
                console.log('组织列表数据:', response.data);
                // 存储后端返回的原始数据（确保包含orgId等核心字段）
                this.personnelList = response.data || [];
                // 筛选和分页初始化
                this.filterPersonnel();
                this.paginateData();
            }).catch((error) => {
                console.error('获取组织列表失败:', error.response || error);
                this.$message({
                    message: error.response?.data?.message || '加载组织列表失败',
                    type: 'error'
                });
                // 异常时清空数据，避免页面展示脏数据
                this.personnelList = [];
                this.filteredPersonnel = [];
                this.pagedPersonnel = [];
            }).finally(() => {
                this.loading = false; // 无论成功失败，都关闭加载状态
            });
        },

        // 2. 筛选组织数据
        filterPersonnel() {
            let result = [...this.personnelList];
            // 按组织名称模糊筛选
            if (this.searchForm.name) {
                const keyword = this.searchForm.name.toLowerCase();
                result = result.filter(item =>
                    item.orgName?.toLowerCase().includes(keyword)
                );
            }
            // 按组织类型精确筛选（若后端返回department字段）
            if (this.searchForm.department) {
                result = result.filter(item =>
                    item.department === this.searchForm.department
                );
            }
            // 按创建时间精确筛选（匹配日期部分，忽略时分秒）
            if (this.searchForm.hireDate) {
                result = result.filter(item =>
                    item.createTime?.split(' ')[0] === this.searchForm.hireDate
                );
            }
            this.filteredPersonnel = result;
        },

        // 3. 分页处理
        paginateData() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.pagedPersonnel = this.filteredPersonnel.slice(startIndex, endIndex);
        },

        // 4. 搜索操作
        search() {
            this.loading = true;
            // 模拟搜索延迟（实际项目可删除，直接调用筛选）
            setTimeout(() => {
                this.currentPage = 1; // 搜索后重置到第一页
                this.filterPersonnel();
                this.paginateData();
                this.loading = false;
            }, 300);
        },



        // 6. 显示新增弹窗
        showAddDialog() {
            this.dialogType = 'add';
            // 重置表单（清空orgId，避免与编辑混淆）
            this.form = {
                orgId: '',
                orgCode: '',
                orgName: ''
            };
            this.dialogVisible = true;
            // 重置表单验证状态
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        // 7. 显示编辑弹窗（回显后端数据）
        showEditDialog(row) {
            this.dialogType = 'edit';
            // 完整回显组织数据（重点传递orgId）
            this.form = {
                orgId: row.orgId, // 必传：后端识别组织的唯一标识
                orgCode: row.orgCode || '',
                orgName: row.orgName || '',
                department: row.department || '' // 若有其他字段，同步回显
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        // 8. 提交表单（新增/编辑统一处理）
        submitForm() {
            this.$refs.formRef.validate((isValid) => {
                if (!isValid) return; // 表单验证失败，不提交

                this.loading = true;
                // 区分新增/编辑接口
                const requestParams = { ...this.form };
                const requestPromise = this.dialogType === 'add'
                    ? addOrg(requestParams)
                    : editOrg(requestParams);

                requestPromise.then(response => {
                    if (response.success || response.code === 200) {
                        this.$message({
                            message: response.message || `${this.dialogType === 'add' ? '新增' : '编辑'}组织成功`,
                            type: 'success'
                        });
                        this.dialogVisible = false; // 关闭弹窗
                        this.getList(); // 重新加载列表，同步后端数据
                    } else {
                        this.$message({
                            message: response.message || `${this.dialogType === 'add' ? '新增' : '编辑'}组织失败`,
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    console.error(`${this.dialogType === 'add' ? '新增' : '编辑'}组织失败:`, error.response || error);
                    this.$message({
                        message: error.response?.data?.message || `网络异常，${this.dialogType === 'add' ? '新增' : '编辑'}失败`,
                        type: 'error'
                    });
                }).finally(() => {
                    this.loading = false;
                });
            });
        },

        // 9. 处理单个删除（核心：调用delOrg接口）
        handleDelete(row) {
            // 确认删除（避免误操作）
            this.$confirm(
                `确定要删除组织「${row.orgName}」吗？删除后数据不可恢复！`,
                '确认删除',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true // 弹窗居中显示，提升用户体验
                }
            ).then(() => {
                this.loading = true;
                // 调用delOrg删除接口，传递组织唯一标识orgId
                delOrg({
                    orgId: row.orgId, // 必传参数：后端根据orgId删除对应组织
                    // 若后端需要其他参数（如tenantId），在此补充
                    // tenantId: null
                }).then(response => {
                    if (response.success || response.code === 200) {
                        this.$message({
                            message: response.message || '删除组织成功',
                            type: 'success'
                        });
                        // 重新加载列表，同步后端删除后的数据
                        this.getList();
                    } else {
                        this.$message({
                            message: response.message || '删除组织失败',
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    console.error('删除组织失败:', error.response || error);
                    this.$message({
                        message: error.response?.data?.message || '网络异常，删除失败',
                        type: 'error'
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                // 用户取消删除时的提示（可选）
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 10. 处理表格选择（批量操作备用）
        handleSelectionChange(selection) {
            this.selectedIds = selection.map(item => item.orgId);
        },

        // 11. 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 页码重置为1
            this.paginateData();
        },

        // 12. 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData();
        }
    }
};
</script>

<style lang="scss" scoped>
/* 样式保持不变，优化细节体验 */
.personnel-management {
    padding: 20px;
    // background-color: #f5f7fa;
    min-height: calc(100vh - 64px);

    .search-panel {
        background-color: #fff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 24px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

        .search-form {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;

            .form-item {
                margin-bottom: 0;

                &.operate-btns {
                    margin-left: auto;
                }
            }

            .search-select,
            .date-picker {
                width: 200px;
            }

            .search-btn,
            .add-btn {
                background-color: #165dff;

                &:hover {
                    background-color: #0e4ada;
                }
            }

            .reset-btn {
                margin-left: 8px;
                background-color: #fff;
                border-color: #dcdfe6;
                color: #606266;

                &:hover {
                    background-color: #f5f7fa;
                }
            }
        }
    }

    .table-container {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        margin-bottom: 24px;

        .personnel-table {
            width: 100%;

            .edit-btn {
                color: #67c23a;

                &:hover {
                    color: #85ce61;
                }
            }

            .delete-btn {
                color: #f56c6c;

                &:hover {
                    color: #f78989;
                }
            }
        }
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 0;

        .pagination {
            margin: 0;
        }
    }

    .form-modal {
        margin-top: 16px;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;

        el-button:first-child {
            background-color: #fff;
            border-color: #dcdfe6;
            color: #606266;

            &:hover {
                background-color: #f5f7fa;
            }
        }

        el-button:last-child {
            background-color: #165dff;

            &:hover {
                background-color: #0e4ada;
            }
        }
    }
}
</style>